export default {
  VITE_ANALYTICS_API_URL: import.meta.env.VITE_ANALYTICS_API_URL,
  VITE_AUDIT_API_URL: import.meta.env.VITE_AUDIT_API_URL,
  VITE_API_URL: import.meta.env.VITE_API_URL,
  VITE_WS_API_URL: import.meta.env.VITE_WS_API_URL,
  VITE_GOOGLE_MAP_API_KEY: import.meta.env.VITE_GOOGLE_MAP_API_KEY,
  VITE_MUI_LICENSE: import.meta.env.VITE_MUI_LICENSE,
  VITE_RESOURCE_INSTRUCTION: import.meta.env.VITE_RESOURCE_INSTRUCTION,
  VITE_RESOURCE_SUPPORT: import.meta.env.VITE_RESOURCE_SUPPORT,
  VITE_FEATURE_LIGHT_DARK_MODE: import.meta.env.VITE_FEATURE_LIGHT_DARK_MODE,
  VITE_FEATURE_FLAG_SWITCHER: import.meta.env.VITE_FEATURE_FLAG_SWITCHER,
  VITE_HOUSEHOLD_URL: import.meta.env.VITE_HOUSEHOLD_URL,
  VITE_CRM_URL: import.meta.env.VITE_CRM_URL,
  VITE_DISTRIBUTION_ADMIN_URL: import.meta.env.VITE_DISTRIBUTION_ADMIN_URL,
  VITE_FEATURE_SHOW_LANGUAGE_SWITCHER: import.meta.env
    .VITE_FEATURE_SHOW_LANGUAGE_SWITCHER,
  VITE_FEATURE_SESSION_MANAGEMENT: import.meta.env
    .VITE_FEATURE_SESSION_MANAGEMENT,
};
